<template>
  <div class="gift-list">
    <div class="left">
      <span class="label">禮物榜</span>
      <div
        class="gift-item"
        v-for="(item, index) of list.slice(0, 5)"
        :key="item.id + '' + index"
      >
        <img :src="item.imageUrl" alt="" />
        <span class="count" v-if="item.count">x{{ item.count }}</span>
      </div>
    </div>
    <i class="el-icon-arrow-right"></i>
  </div>
</template>
<script>
export default {
  name: 'GiftList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.gift-list {
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  background: rgba(66, 73, 113, 0.5);
  width: calc(100% - 40px);
  padding: 10px 20px;
  margin: 0 20px;
  cursor: pointer;

  .left {
    display: flex;
    align-items: center;
    overflow: hidden;
    .label {
      flex: none;
      margin-right: 8px;
    }
    .gift-item {
      display: inline-block;
      position: relative;
      margin-right: 10px;
      flex: none;
    }
    .count {
      position: absolute;
      font-size: 12px;
      padding: 2px 4px;
      border-radius: 8px;
      color: white;
      background-color: #f72586;
      transform: scale(0.7);
      right: -4px;
      top: -4px;
    }
    img {
      width: 30px;
      height: auto;
    }
  }

  .el-icon-arrow-right {
    flex: none;
  }
}
</style>
